module.exports = __webpack_public_path__ + "static/media/emptyWorkflowPage.ebaf9ad6.svg";